import "./BackgroundWrapper.css";

const BackgroundWrapper = ({children}) => {
    return (<div className={"background"}>{children}</div>);
}

export { BackgroundWrapper }